import { useContext } from 'react';
import clsx from 'clsx';

import UserGroupIcon from '@atom/components/common/UserGroupIcon';
import AddTeamModalContext from '@atom/components/common/workOrderDetail/addTeamModal/AddTeamModalContext';
import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { UserGroup } from '@atom/types/userGroups';
import { pluralize } from '@atom/utilities/stringUtilities';

import classes from './searchTab.module.css';

interface Props {
  userGroup: UserGroup;
}

const UserGroupRow = ({ userGroup }: Props) => {
  const {
    userGroupsOnTask,
    selectedUserGroups,
    removeUserGroupFromCart,
    addUserGroupToCart,
  } = useContext(AddTeamModalContext);

  const isOnTask = userGroupsOnTask.includes(userGroup.id);
  const isSelected = selectedUserGroups
    .map(selectedUserGroup => selectedUserGroup.id)
    .includes(userGroup.id);

  const getTitleStyle = (base: string) => {
    return clsx(
      base,
      isSelected && classes.selected,
      isOnTask && classes.disabled,
    );
  };

  const onClick = () => {
    if (isSelected) {
      return removeUserGroupFromCart(userGroup.id);
    }

    if (isOnTask) {
      return () => {};
    }

    return addUserGroupToCart(userGroup);
  };

  return (
    <div className={classes.groupRow} onClick={onClick}>
      <div className={classes.leftContainer}>
        <UserGroupIcon colorId={userGroup.colorId} disabled={isOnTask} />
        <div className={classes.nameContainer}>
          <div className={getTitleStyle(classes.title)}>{userGroup.name}</div>
          <div className={getTitleStyle(classes.subtitle)}>
            {userGroup.userCount} {pluralize(userGroup.userCount, 'User')}
          </div>
        </div>
      </div>
      {isSelected && <Icon color={colors.brand.blue}>check</Icon>}
    </div>
  );
};

export default UserGroupRow;
